import axiosInstance from '@/libs/axiosInstance';
import type { Program } from '@fluenceur/types';
import { useMutation } from '@tanstack/react-query';

interface UpdateProgramVariables<TPayload> {
  programId: string;
  payload: TPayload;
}

/**
 * The program update, as `services/affiliate-programs-service` performed it:
 * one PUT returning the program. Same request, same response, now a mutation
 * hook so the forms stop reaching into the deprecated services layer.
 */
export const useUpdateProgram = <TPayload>() =>
  useMutation<Program, Error, UpdateProgramVariables<TPayload>>({
    mutationFn: async ({ programId, payload }) => {
      const response = await axiosInstance.put<Program>(`/dashboard/programs/${programId}`, payload);
      return response.data;
    },
  });
